import apiHttpClient from "./ApiHttpClient";

export default class FavoriteRepository {

  /**
   * favorChapter
   *
   * @param {number} chapterId
   * @param {boolean|null} isCompanyChapter
   * @returns {void}
   */
  async favor(chapterId, isCompanyChapter = false) {
    try {
      const res = await apiHttpClient.post('/favorite/favor', {
        chapter_id: chapterId,
        is_company_chapter: isCompanyChapter,
      });
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * unFavor
   *
   * @param {number} chapterId
   * @param {boolean|null} isCompanyChapter
   * @returns {void}
   */
  async unFavor(chapterId, isCompanyChapter = false) {
    try {
      const res = await apiHttpClient.post('/favorite/unfavor', {
        chapter_id: chapterId,
        is_company_chapter: isCompanyChapter,
      });
      return res.data;
    } catch (error) {
      throw error;
    }
  }
}
